/**
 * useStrategyDescriptionCovers
 *
 * Fetches the latest cover images for all three strategy descriptions
 * from the CMS. Used by LibraryPage for the strategy description carousel.
 *
 * Covers may be JPG/PNG/WEBP images or PDFs (PDFs are rendered in an iframe
 * by InfoCard).
 *
 * Returns:
 * {
 *   loading: boolean,
 *   error: string | null,
 *   covers: {
 *     'strand-q': { url, year, month, label } | null,
 *     'merin': { url, year, month, label } | null,
 *     'dravon': { url, year, month, label } | null
 *   }
 * }
 */

import { useState, useEffect } from 'react';

import { getStrategyDescriptionCover } from '../services/cmsService';

const useStrategyDescriptionCovers = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [covers, setCovers] = useState({
    'strand-q': null,
    merin: null,
    dravon: null
  });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const [strandQ, merin, dravon] = await Promise.all([
          getStrategyDescriptionCover('strand-q'),
          getStrategyDescriptionCover('merin'),
          getStrategyDescriptionCover('dravon')
        ]);

        if (cancelled) return;

        setCovers({
          'strand-q': strandQ,
          merin: merin,
          dravon: dravon
        });
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load strategy covers');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { loading, error, covers };
};

export default useStrategyDescriptionCovers;
